import { render, staticRenderFns } from "./assessment-auth.vue?vue&type=template&id=509da347&scoped=true"
import script from "./assessment-auth.vue?vue&type=script&lang=js"
export * from "./assessment-auth.vue?vue&type=script&lang=js"
import style0 from "./assessment-auth.vue?vue&type=style&index=0&id=509da347&prod&lang=css"
import style1 from "./assessment-auth.vue?vue&type=style&index=1&id=509da347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509da347",
  null
  
)

export default component.exports